import { render, staticRenderFns } from "./Mensagens-recebidas copy.vue?vue&type=template&id=f1247f0a&scoped=true&"
import script from "./Mensagens-recebidas copy.vue?vue&type=script&lang=js&"
export * from "./Mensagens-recebidas copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1247f0a",
  null
  
)

export default component.exports